/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-import-module-exports */
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

import rootReducer from 'rdx';

const configStore = () => {
  const middleWare = [thunk];

  const composeEnhancers = composeWithDevTools({ trace: true });
  const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(...middleWare)),
  );
  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('rdx', () => {
      // eslint-disable-next-line global-require
      const nextReducer = require('rdx').default;
      store.replaceReducer(nextReducer);
    });
  }

  return store;
};

const store = configStore();

export default store;
